import script from "./CurrencyPair.vue?vue&type=script&setup=true&lang=ts"
export * from "./CurrencyPair.vue?vue&type=script&setup=true&lang=ts"

import "./CurrencyPair.vue?vue&type=style&index=0&id=04c4e343&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04c4e343"]])

export default __exports__